export default {
  title: 'Please annotate according to the requirements.',
  invalidTask: 'Invalid audio',
  role: 'Role',
  STA: 'Throughout background noise',
  NON: 'Abrupt non-speech noise',
  FIL: 'Modal particle (speaker)',
  RSP: 'Modal particle (non-speaker)',
  SPK: 'Speaker noise',
  NPS: 'Non-speaker noise',
  region: 'Select an excerpt',
  please: 'Please enter',
  appNotify1: 'Please finish all the annotation',
  appNotify2: ', at least one excerpt ',
  appNotify3: ', ensure the starting position is at 0.000',
  appNotify4: ', ensure that the last position is at the end',
  add: ' add ',
  appNotify5: 'Don’t connect the starting position and the last position',
  appNotify6: 'Excerpt content incomplete',
  waveNotify1: 'Maximum',
  waveNotify2: 'Minimum ',
  current: 'Present',
  deafness: 'Vague and uncertain '
}



// WEBPACK FOOTER //
// ./src/lang/en/task3Do.js